export const initialCall = {
  status: 'idle', // idle | connecting | active | ended | error
  phase: null, // null | connecting | listening | thinking | speaking
  agentSpeaking: false,
  userSpeaking: false,
  error: null,
  transcript: [], // [{ id, text, final }]
};

export function reduceCall(state, action) {
  if (state.status === 'error' && action.type !== 'RESET') return state;
  switch (action.type) {
    case 'CONNECT':
      return { ...initialCall, status: 'connecting', phase: 'connecting' };
    case 'CONNECTED':
      // Room is live; don't keep showing "Connecting…" while waiting for lk.agent.state.
      return { ...state, status: 'active', phase: 'listening' };
    case 'AGENT_STATE': {
      // Map LiveKit agent states (lk.agent.state) to our phases.
      switch (action.value) {
        case 'listening':
          return { ...state, phase: 'listening' };
        case 'thinking':
          return { ...state, phase: 'thinking' };
        case 'speaking':
          return { ...state, phase: 'speaking' };
        default:
          // idle | initializing | null: keep current phase, but settle to
          // 'listening' once the call is active and we have no phase yet.
          if (state.status === 'active' && !state.phase) {
            return { ...state, phase: 'listening' };
          }
          return state;
      }
    }
    case 'AGENT_SPEAKING':
      return { ...state, agentSpeaking: !!action.value };
    case 'USER_SPEAKING':
      return { ...state, userSpeaking: !!action.value };
    case 'TRANSCRIPT': {
      const rest = state.transcript.filter(t => t.id !== action.id);
      return {
        ...state,
        transcript: [...rest, { id: action.id, text: action.text, final: !!action.final }],
      };
    }
    case 'END':
      return { ...state, status: 'ended', phase: null };
    case 'ERROR':
      return { ...state, status: 'error', error: action.error };
    case 'RESET':
      return { ...initialCall };
    default:
      return state;
  }
}
